import { useEffect } from "react";
import { useCustomerAppConfig } from "@wayflyer/undercarriage";
import { Navigate, useLocation } from "react-router";

export const HowToApplyApp = () => {
  const {
    data: { userEmail },
  } = useCustomerAppConfig();
  const location = useLocation();

  useEffect(() => {
    if (!userEmail) {
      localStorage.setItem("wf-initial-product-choice", "funding");
      const params = new URLSearchParams(location.search);
      params.delete("step");
      params.delete("animate");
      const search = params.toString();
      window.location.replace(search.length > 0 ? `/authn/signup?${search}` : "/authn/signup");
    }
  }, [userEmail, location.search]);

  if (userEmail) {
    return <Navigate to="/" />;
  }

  return null;
};
